import { List } from '@kerfjs/ui/list';
import { ListHeader } from '@kerfjs/ui/list-header';
import { ListItem } from '@kerfjs/ui/list-item';
import type { SafeHtml } from 'kerfjs';

import { savingsPeriod } from '../../../data/state.js';
import { SAVINGS_PERIODS } from '../../../lib/savings-period.js';

/** Savings reporting-period navigation. */
export function StatsSidebar(): SafeHtml {
  return (
    <List className="stats-sidebar">
      <ListHeader label="Savings" />
      {SAVINGS_PERIODS.map((period) => (
        <ListItem
          label={period.label}
          action="savings-period-nav"
          itemId={period.value}
          selected={period.value === savingsPeriod.value}
        />
      ))}
    </List>
  );
}
